export default function Footer() {
    return (
      <footer className="footer flex justify-center items-center md:pt-[-30%] pt-[5%] pb-[5%]">
        <div className="footer-content">
          <p className="copyright text-center">Copyright © 2023 | RexRide App</p>
        </div>
      </footer>
    );
  }
  